/**
 * Web shim for react-native-view-shot.
 *
 * The package's shared wrapper routes every capture through
 * `findNodeHandle`, which RN-web has removed ("not supported on web") —
 * but the package itself ships a working html2canvas implementation
 * (src/RNViewShot.web.js). This shim resolves RN-web View refs to their
 * DOM node and calls it directly, returning a full data URI.
 */
const RNViewShotMod = require('react-native-view-shot/src/RNViewShot.web.js');
const RNViewShot = RNViewShotMod.default || RNViewShotMod;

const toDomNode = (view) => {
  const node = view && 'current' in view ? view.current : view;
  if (!node) return null;
  if (typeof Node !== 'undefined' && node instanceof Node) return node;
  // Older RN-web class instances expose the DOM node indirectly.
  if (typeof node.getDOMNode === 'function') return node.getDOMNode();
  if (node instanceof Element) return node;
  return null;
};

async function captureRef(view, optionsObject) {
  const el = toDomNode(view);
  if (!el) return Promise.reject(new Error('captureRef: could not resolve a DOM node for web'));
  const dataUri = await RNViewShot.captureRef(el, optionsObject || {});
  // The package strips the data-uri prefix by default; keep it — web flows
  // (download / share sheet) want the full data URI.
  if (optionsObject && optionsObject.result && optionsObject.result !== 'data-uri') {
    return dataUri;
  }
  return dataUri.startsWith('data:') ? dataUri : `data:image/${optionsObject?.format || 'png'};base64,${dataUri}`;
}

module.exports = {
  __esModule: true,
  default: { captureRef, captureScreen: RNViewShot.captureScreen, releaseCapture: () => {} },
  captureRef,
  captureScreen: RNViewShot.captureScreen,
  releaseCapture: () => {},
};